import { Breakpoints } from "@/shared/styles/breakpoints";
import styled from "styled-components";
import * as zero from '@zero/design-tokens/build/js/variables'


interface ImageProps {
    size: number
}

export const StyledImage = styled.img<ImageProps>`
    height: ${(props) => `${props.size}px`};
    margin-right: ${zero.ZrSpacingHorizontalNano};

    @media (max-width: ${Breakpoints.menu}) {
        height: ${(props) => `${props.size - 5}px`};

    }
`